// Textos das Ausências do DP (01/11/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.ausencias.titulo': 'Ausências',
    'dp.ausencias.ajuda': 'Junta o que o DP cadastra no Hub com os afastamentos e as férias programadas que vêm do arquivo do Protheus, que aparecem só para leitura. Quando as duas fontes falam do mesmo período, vale o Hub. A situação na Logística acompanha a ausência do Hub no dia certo, e férias e afastamento continuam só avisando na escala, sem bloquear.',
    'dp.ausencias.nova': 'Nova ausência',
    'dp.ausencias.editar': 'Editar ausência',
    'dp.ausencias.abrir': 'Abrir',
    'dp.ausencias.salva': 'Ausência salva.',
    'dp.ausencias.visao': 'Visualização',
    'dp.ausencias.visao.relatorio': 'Relatório',
    'dp.ausencias.visao.calendario': 'Calendário',
    'dp.ausencias.visao.linha': 'Linha do tempo',
    'dp.ausencias.visao.quadro': 'Quadro por setor',
    'dp.ausencias.kpi.hoje': 'Em ausência hoje',
    'dp.ausencias.kpi.comecam': 'Começam em 7 dias',
    'dp.ausencias.kpi.retornam': 'Retornam em 7 dias',
    'dp.ausencias.kpi.semPrevisao': 'Sem previsão',
    'dp.ausencias.kpi.grupoHoje': 'Em ausência hoje neste grupo',
    'dp.ausencias.grupo': 'Grupo',
    'dp.ausencias.grupo.todos': 'Todos os grupos',
    'dp.ausencias.kpi.grupo.ferias': 'Férias',
    'dp.ausencias.kpi.grupo.afastamento': 'Afastados',
    'dp.ausencias.kpi.grupo.atestado': 'Atestado',
    'dp.ausencias.kpi.grupo.licenca': 'Licença',
    'dp.ausencias.kpi.grupo.outro': 'Outro',
    'dp.ausencias.grupo.ferias': 'Férias',
    'dp.ausencias.grupo.afastamento': 'Afastamento',
    'dp.ausencias.grupo.atestado': 'Atestado',
    'dp.ausencias.grupo.licenca': 'Licença',
    'dp.ausencias.grupo.outro': 'Outro',
    'dp.ausencias.tipo': 'Tipo',
    'dp.ausencias.tipo.todos': 'Todos os tipos',
    'dp.ausencias.inicio': 'Início',
    'dp.ausencias.fim': 'Fim',
    'dp.ausencias.dias': 'Dias',
    'dp.ausencias.origem': 'Origem',
    'dp.ausencias.origem.todas': 'Todas as origens',
    'dp.ausencias.origem.hub': 'Hub',
    'dp.ausencias.origem.arquivo': 'Arquivo do Protheus',
    'dp.ausencias.situacao.todas': 'Menos canceladas',
    'dp.ausencias.situacao.programada': 'Programada',
    'dp.ausencias.situacao.em_andamento': 'Em andamento',
    'dp.ausencias.situacao.sem_previsao': 'Sem previsão',
    'dp.ausencias.situacao.encerrada': 'Encerrada',
    'dp.ausencias.situacao.cancelada': 'Cancelada',
    'dp.ausencias.maisFiltros': 'Mais filtros',
    'dp.ausencias.de': 'De',
    'dp.ausencias.ate': 'Até',
    'dp.ausencias.semPrevisao': 'Sem previsão',
    'dp.ausencias.semPrevisaoUm': '1 sem previsão',
    'dp.ausencias.semPrevisaoN': '{{n}} sem previsão',
    'dp.ausencias.funcao': 'Função',
    'dp.ausencias.matricula': 'Matrícula',
    'dp.ausencias.base': 'Base',
    'dp.ausencias.retornoEm': 'Retorno',
    'dp.ausencias.previsto': 'Previsto para {{dia}}',
    'dp.ausencias.voltaEm': 'Volta em {{dia}}',
    'dp.ausencias.periodo.aberto': 'Desde {{inicio}}, sem previsão',
    'dp.ausencias.periodo.umDia': 'Em {{dia}}',
    'dp.ausencias.periodo.fechado': 'De {{inicio}} a {{fim}}',
    'dp.ausencias.doArquivo': 'Esta ausência vem do arquivo do Protheus e aparece só para leitura. Para corrigir, cadastre a ausência no Hub, que passa a valer no lugar dela.',
    'dp.ausencias.prorrogar': 'Prorrogar',
    'dp.ausencias.registrarRetorno': 'Registrar retorno',
    'dp.ausencias.retornoDe': 'A data em que {{nome}} voltou.',
    'dp.ausencias.dataDoRetorno': 'Data do retorno',
    'dp.ausencias.retornoSalvo': 'Retorno registrado.',
    'dp.ausencias.cancelar': 'Cancelar ausência',
    'dp.ausencias.motivo': 'Motivo do cancelamento',
    'dp.ausencias.cancelada': 'Ausência cancelada.',
    'dp.ausencias.form.semPessoa': 'Escolha a pessoa.',
    'dp.ausencias.form.semTipo': 'Escolha o tipo da ausência.',
    'dp.ausencias.form.semInicio': 'Informe o início.',
    'dp.ausencias.form.semFim': 'Informe o fim ou marque sem previsão.',
    'dp.ausencias.form.semCid': 'Não escreva CID nem motivo de saúde.',
    'dp.ausencias.form.ninguem': 'Ninguém encontrado.',
    'dp.ausencias.mesAnterior': 'Mês anterior',
    'dp.ausencias.proximoMes': 'Próximo mês',
    'dp.ausencias.semana.0': 'Dom',
    'dp.ausencias.semana.1': 'Seg',
    'dp.ausencias.semana.2': 'Ter',
    'dp.ausencias.semana.3': 'Qua',
    'dp.ausencias.semana.4': 'Qui',
    'dp.ausencias.semana.5': 'Sex',
    'dp.ausencias.semana.6': 'Sáb',
    'dp.ausencias.maisN': '+ {{n}} mais',
    'dp.ausencias.doDia': 'Ausências de {{dia}}',
    'dp.ausencias.semNoPeriodo': 'Nenhuma ausência neste período com estes filtros.',
    'dp.ausencias.teto': 'Este período tem {{total}} ausências e a tela mostra até {{teto}}. Filtre para ver todas.',
    'dp.ausencias.janela': 'Janela',
    'dp.ausencias.janela.um': '1 mês',
    'dp.ausencias.janela.tres': '3 meses',
    'dp.ausencias.janelaDeMeses': '{{de}} a {{ate}}',
    'dp.ausencias.setor': 'Setor',
    'dp.ausencias.semSetor': 'Sem setor',
    'dp.ausencias.ativos': 'Ativos',
    'dp.ausencias.ausentes': 'Ausentes',
    'dp.ausencias.proximaPrevisao': 'Próxima previsão de retorno',
    'dp.ausencias.quadroVazio': 'O quadro do Protheus ainda não chegou pela tela de Arquivos.',
    'dp.ausencias.baseLida': 'Base de ativos lida em {{data}}',
    'dp.ausencias.tipos.titulo': 'Tipos de ausência',
    'dp.ausencias.tipos.novo': 'Novo tipo',
    'dp.ausencias.tipos.editar': 'Editar',
    'dp.ausencias.tipos.nome': 'Nome',
    'dp.ausencias.tipos.semNome': 'Informe o nome do tipo.',
    'dp.ausencias.tipos.salvo': 'Tipo salvo.',
    'dp.ausencias.tipos.logistica': 'Situação na Logística',
    'dp.ausencias.tipos.logistica.nenhuma': 'Não muda',
    'dp.ausencias.tipos.logistica.ferias': 'Férias',
    'dp.ausencias.tipos.logistica.afastado': 'Afastado',
    'dp.ausencias.tipos.descontaVale': 'Desconta o vale',
    'dp.ausencias.tipos.sim': 'Sim',
    'dp.ausencias.tipos.nao': 'Não',
    'dp.ausencias.tipos.ativo': 'Ativo',
    'dp.ausencias.tipos.inativo': 'Desativado',
    'dp.inicio.ausencias.subtitulo': 'Quem está fora, e quando volta',
  },
  en: {
    'dp.ausencias.titulo': 'Absences',
    'dp.ausencias.ajuda': 'Combines what HR registers in the Hub with the leaves and scheduled vacations from the Protheus file, which are read only. When both sources cover the same period, the Hub wins. The status in Logistics follows the Hub absence on the right day, and vacations and leaves still only warn on the schedule, without blocking.',
    'dp.ausencias.nova': 'New absence',
    'dp.ausencias.editar': 'Edit absence',
    'dp.ausencias.abrir': 'Open',
    'dp.ausencias.salva': 'Absence saved.',
    'dp.ausencias.visao': 'View',
    'dp.ausencias.visao.relatorio': 'Report',
    'dp.ausencias.visao.calendario': 'Calendar',
    'dp.ausencias.visao.linha': 'Timeline',
    'dp.ausencias.visao.quadro': 'Headcount by department',
    'dp.ausencias.kpi.hoje': 'Absent today',
    'dp.ausencias.kpi.comecam': 'Starting in 7 days',
    'dp.ausencias.kpi.retornam': 'Returning in 7 days',
    'dp.ausencias.kpi.semPrevisao': 'No end date',
    'dp.ausencias.kpi.grupoHoje': 'Absent today in this group',
    'dp.ausencias.grupo': 'Group',
    'dp.ausencias.grupo.todos': 'All groups',
    'dp.ausencias.kpi.grupo.ferias': 'Vacation',
    'dp.ausencias.kpi.grupo.afastamento': 'On leave',
    'dp.ausencias.kpi.grupo.atestado': 'Medical note',
    'dp.ausencias.kpi.grupo.licenca': 'Statutory leave',
    'dp.ausencias.kpi.grupo.outro': 'Other',
    'dp.ausencias.grupo.ferias': 'Vacation',
    'dp.ausencias.grupo.afastamento': 'Leave',
    'dp.ausencias.grupo.atestado': 'Medical note',
    'dp.ausencias.grupo.licenca': 'Statutory leave',
    'dp.ausencias.grupo.outro': 'Other',
    'dp.ausencias.tipo': 'Type',
    'dp.ausencias.tipo.todos': 'All types',
    'dp.ausencias.inicio': 'Start',
    'dp.ausencias.fim': 'End',
    'dp.ausencias.dias': 'Days',
    'dp.ausencias.origem': 'Source',
    'dp.ausencias.origem.todas': 'All sources',
    'dp.ausencias.origem.hub': 'Hub',
    'dp.ausencias.origem.arquivo': 'Protheus file',
    'dp.ausencias.situacao.todas': 'All but cancelled',
    'dp.ausencias.situacao.programada': 'Scheduled',
    'dp.ausencias.situacao.em_andamento': 'In progress',
    'dp.ausencias.situacao.sem_previsao': 'No end date',
    'dp.ausencias.situacao.encerrada': 'Finished',
    'dp.ausencias.situacao.cancelada': 'Cancelled',
    'dp.ausencias.maisFiltros': 'More filters',
    'dp.ausencias.de': 'From',
    'dp.ausencias.ate': 'To',
    'dp.ausencias.semPrevisao': 'No end date',
    'dp.ausencias.semPrevisaoUm': '1 with no end date',
    'dp.ausencias.semPrevisaoN': '{{n}} with no end date',
    'dp.ausencias.funcao': 'Role',
    'dp.ausencias.matricula': 'Employee number',
    'dp.ausencias.base': 'Base',
    'dp.ausencias.retornoEm': 'Return',
    'dp.ausencias.previsto': 'Expected on {{dia}}',
    'dp.ausencias.voltaEm': 'Returns on {{dia}}',
    'dp.ausencias.periodo.aberto': 'Since {{inicio}}, no end date',
    'dp.ausencias.periodo.umDia': 'On {{dia}}',
    'dp.ausencias.periodo.fechado': 'From {{inicio}} to {{fim}}',
    'dp.ausencias.doArquivo': 'This absence comes from the Protheus file and is read only. To correct it, register the absence in the Hub, which takes its place.',
    'dp.ausencias.prorrogar': 'Extend',
    'dp.ausencias.registrarRetorno': 'Register return',
    'dp.ausencias.retornoDe': 'The date {{nome}} came back.',
    'dp.ausencias.dataDoRetorno': 'Return date',
    'dp.ausencias.retornoSalvo': 'Return registered.',
    'dp.ausencias.cancelar': 'Cancel absence',
    'dp.ausencias.motivo': 'Cancellation reason',
    'dp.ausencias.cancelada': 'Absence cancelled.',
    'dp.ausencias.form.semPessoa': 'Choose the person.',
    'dp.ausencias.form.semTipo': 'Choose the absence type.',
    'dp.ausencias.form.semInicio': 'Enter the start date.',
    'dp.ausencias.form.semFim': 'Enter the end date or mark no end date.',
    'dp.ausencias.form.semCid': 'Do not write ICD codes or health reasons.',
    'dp.ausencias.form.ninguem': 'No one found.',
    'dp.ausencias.mesAnterior': 'Previous month',
    'dp.ausencias.proximoMes': 'Next month',
    'dp.ausencias.semana.0': 'Sun',
    'dp.ausencias.semana.1': 'Mon',
    'dp.ausencias.semana.2': 'Tue',
    'dp.ausencias.semana.3': 'Wed',
    'dp.ausencias.semana.4': 'Thu',
    'dp.ausencias.semana.5': 'Fri',
    'dp.ausencias.semana.6': 'Sat',
    'dp.ausencias.maisN': '+ {{n}} more',
    'dp.ausencias.doDia': 'Absences on {{dia}}',
    'dp.ausencias.semNoPeriodo': 'No absences in this period with these filters.',
    'dp.ausencias.teto': 'This period has {{total}} absences and the screen shows up to {{teto}}. Filter to see them all.',
    'dp.ausencias.janela': 'Window',
    'dp.ausencias.janela.um': '1 month',
    'dp.ausencias.janela.tres': '3 months',
    'dp.ausencias.janelaDeMeses': '{{de}} to {{ate}}',
    'dp.ausencias.setor': 'Department',
    'dp.ausencias.semSetor': 'No department',
    'dp.ausencias.ativos': 'Active',
    'dp.ausencias.ausentes': 'Absent',
    'dp.ausencias.proximaPrevisao': 'Next expected return',
    'dp.ausencias.quadroVazio': 'The Protheus headcount has not arrived through the Files screen yet.',
    'dp.ausencias.baseLida': 'Active staff file read on {{data}}',
    'dp.ausencias.tipos.titulo': 'Absence types',
    'dp.ausencias.tipos.novo': 'New type',
    'dp.ausencias.tipos.editar': 'Edit',
    'dp.ausencias.tipos.nome': 'Name',
    'dp.ausencias.tipos.semNome': 'Enter the type name.',
    'dp.ausencias.tipos.salvo': 'Type saved.',
    'dp.ausencias.tipos.logistica': 'Status in Logistics',
    'dp.ausencias.tipos.logistica.nenhuma': 'Unchanged',
    'dp.ausencias.tipos.logistica.ferias': 'Vacation',
    'dp.ausencias.tipos.logistica.afastado': 'On leave',
    'dp.ausencias.tipos.descontaVale': 'Deducts meal voucher',
    'dp.ausencias.tipos.sim': 'Yes',
    'dp.ausencias.tipos.nao': 'No',
    'dp.ausencias.tipos.ativo': 'Active',
    'dp.ausencias.tipos.inativo': 'Disabled',
    'dp.inicio.ausencias.subtitulo': 'Who is out, and when they return',
  },
  es: {
    'dp.ausencias.titulo': 'Ausencias',
    'dp.ausencias.ajuda': 'Reúne lo que RR. HH. registra en el Hub con las licencias y las vacaciones programadas del archivo de Protheus, que solo se leen. Cuando las dos fuentes hablan del mismo período, vale el Hub. La situación en Logística sigue la ausencia del Hub en el día correcto, y vacaciones y licencias siguen solo avisando en la escala, sin bloquear.',
    'dp.ausencias.nova': 'Nueva ausencia',
    'dp.ausencias.editar': 'Editar ausencia',
    'dp.ausencias.abrir': 'Abrir',
    'dp.ausencias.salva': 'Ausencia guardada.',
    'dp.ausencias.visao': 'Visualización',
    'dp.ausencias.visao.relatorio': 'Informe',
    'dp.ausencias.visao.calendario': 'Calendario',
    'dp.ausencias.visao.linha': 'Línea de tiempo',
    'dp.ausencias.visao.quadro': 'Plantilla por sector',
    'dp.ausencias.kpi.hoje': 'Ausentes hoy',
    'dp.ausencias.kpi.comecam': 'Empiezan en 7 días',
    'dp.ausencias.kpi.retornam': 'Vuelven en 7 días',
    'dp.ausencias.kpi.semPrevisao': 'Sin previsión',
    'dp.ausencias.kpi.grupoHoje': 'Ausentes hoy en este grupo',
    'dp.ausencias.grupo': 'Grupo',
    'dp.ausencias.grupo.todos': 'Todos los grupos',
    'dp.ausencias.kpi.grupo.ferias': 'Vacaciones',
    'dp.ausencias.kpi.grupo.afastamento': 'De baja',
    'dp.ausencias.kpi.grupo.atestado': 'Certificado',
    'dp.ausencias.kpi.grupo.licenca': 'Licencia',
    'dp.ausencias.kpi.grupo.outro': 'Otro',
    'dp.ausencias.grupo.ferias': 'Vacaciones',
    'dp.ausencias.grupo.afastamento': 'Baja',
    'dp.ausencias.grupo.atestado': 'Certificado',
    'dp.ausencias.grupo.licenca': 'Licencia',
    'dp.ausencias.grupo.outro': 'Otro',
    'dp.ausencias.tipo': 'Tipo',
    'dp.ausencias.tipo.todos': 'Todos los tipos',
    'dp.ausencias.inicio': 'Inicio',
    'dp.ausencias.fim': 'Fin',
    'dp.ausencias.dias': 'Días',
    'dp.ausencias.origem': 'Origen',
    'dp.ausencias.origem.todas': 'Todos los orígenes',
    'dp.ausencias.origem.hub': 'Hub',
    'dp.ausencias.origem.arquivo': 'Archivo de Protheus',
    'dp.ausencias.situacao.todas': 'Salvo canceladas',
    'dp.ausencias.situacao.programada': 'Programada',
    'dp.ausencias.situacao.em_andamento': 'En curso',
    'dp.ausencias.situacao.sem_previsao': 'Sin previsión',
    'dp.ausencias.situacao.encerrada': 'Terminada',
    'dp.ausencias.situacao.cancelada': 'Cancelada',
    'dp.ausencias.maisFiltros': 'Más filtros',
    'dp.ausencias.de': 'Desde',
    'dp.ausencias.ate': 'Hasta',
    'dp.ausencias.semPrevisao': 'Sin previsión',
    'dp.ausencias.semPrevisaoUm': '1 sin previsión',
    'dp.ausencias.semPrevisaoN': '{{n}} sin previsión',
    'dp.ausencias.funcao': 'Función',
    'dp.ausencias.matricula': 'Matrícula',
    'dp.ausencias.base': 'Base',
    'dp.ausencias.retornoEm': 'Retorno',
    'dp.ausencias.previsto': 'Previsto para {{dia}}',
    'dp.ausencias.voltaEm': 'Vuelve el {{dia}}',
    'dp.ausencias.periodo.aberto': 'Desde {{inicio}}, sin previsión',
    'dp.ausencias.periodo.umDia': 'El {{dia}}',
    'dp.ausencias.periodo.fechado': 'Del {{inicio}} al {{fim}}',
    'dp.ausencias.doArquivo': 'Esta ausencia viene del archivo de Protheus y solo se lee. Para corregirla, registre la ausencia en el Hub, que pasa a valer en su lugar.',
    'dp.ausencias.prorrogar': 'Prorrogar',
    'dp.ausencias.registrarRetorno': 'Registrar retorno',
    'dp.ausencias.retornoDe': 'La fecha en que {{nome}} volvió.',
    'dp.ausencias.dataDoRetorno': 'Fecha del retorno',
    'dp.ausencias.retornoSalvo': 'Retorno registrado.',
    'dp.ausencias.cancelar': 'Cancelar ausencia',
    'dp.ausencias.motivo': 'Motivo de la cancelación',
    'dp.ausencias.cancelada': 'Ausencia cancelada.',
    'dp.ausencias.form.semPessoa': 'Elija la persona.',
    'dp.ausencias.form.semTipo': 'Elija el tipo de ausencia.',
    'dp.ausencias.form.semInicio': 'Informe el inicio.',
    'dp.ausencias.form.semFim': 'Informe el fin o marque sin previsión.',
    'dp.ausencias.form.semCid': 'No escriba CIE ni motivo de salud.',
    'dp.ausencias.form.ninguem': 'Nadie encontrado.',
    'dp.ausencias.mesAnterior': 'Mes anterior',
    'dp.ausencias.proximoMes': 'Mes siguiente',
    'dp.ausencias.semana.0': 'Dom',
    'dp.ausencias.semana.1': 'Lun',
    'dp.ausencias.semana.2': 'Mar',
    'dp.ausencias.semana.3': 'Mié',
    'dp.ausencias.semana.4': 'Jue',
    'dp.ausencias.semana.5': 'Vie',
    'dp.ausencias.semana.6': 'Sáb',
    'dp.ausencias.maisN': '+ {{n}} más',
    'dp.ausencias.doDia': 'Ausencias del {{dia}}',
    'dp.ausencias.semNoPeriodo': 'Ninguna ausencia en este período con estos filtros.',
    'dp.ausencias.teto': 'Este período tiene {{total}} ausencias y la pantalla muestra hasta {{teto}}. Filtre para verlas todas.',
    'dp.ausencias.janela': 'Ventana',
    'dp.ausencias.janela.um': '1 mes',
    'dp.ausencias.janela.tres': '3 meses',
    'dp.ausencias.janelaDeMeses': '{{de}} a {{ate}}',
    'dp.ausencias.setor': 'Sector',
    'dp.ausencias.semSetor': 'Sin sector',
    'dp.ausencias.ativos': 'Activos',
    'dp.ausencias.ausentes': 'Ausentes',
    'dp.ausencias.proximaPrevisao': 'Próxima previsión de retorno',
    'dp.ausencias.quadroVazio': 'La plantilla de Protheus aún no llegó por la pantalla de Archivos.',
    'dp.ausencias.baseLida': 'Base de activos leída el {{data}}',
    'dp.ausencias.tipos.titulo': 'Tipos de ausencia',
    'dp.ausencias.tipos.novo': 'Nuevo tipo',
    'dp.ausencias.tipos.editar': 'Editar',
    'dp.ausencias.tipos.nome': 'Nombre',
    'dp.ausencias.tipos.semNome': 'Informe el nombre del tipo.',
    'dp.ausencias.tipos.salvo': 'Tipo guardado.',
    'dp.ausencias.tipos.logistica': 'Situación en Logística',
    'dp.ausencias.tipos.logistica.nenhuma': 'No cambia',
    'dp.ausencias.tipos.logistica.ferias': 'Vacaciones',
    'dp.ausencias.tipos.logistica.afastado': 'De baja',
    'dp.ausencias.tipos.descontaVale': 'Descuenta el vale',
    'dp.ausencias.tipos.sim': 'Sí',
    'dp.ausencias.tipos.nao': 'No',
    'dp.ausencias.tipos.ativo': 'Activo',
    'dp.ausencias.tipos.inativo': 'Desactivado',
    'dp.inicio.ausencias.subtitulo': 'Quién está fuera, y cuándo vuelve',
  },
}
